import { render, staticRenderFns } from "./InformationRequested.vue?vue&type=template&id=20d06f36&"
import script from "./InformationRequested.vue?vue&type=script&lang=js&"
export * from "./InformationRequested.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports